import React from "react";

export default function Footer() {
  const handleClick = (e) => {
    e.preventDefault();

    // Build "vstrueve@propelschools.org" without exposing it in the DOM
    const u = ["v","s","t","r","u","e","v","e"].join("");
    const d = ["p","r","o","p","e","l","s","c","h","o","o","l","s"].join("");
    const t = "org";
    const email = `${u}@${d}.${t}`;

    const subject = "PropelPoints — Idea or Help Request";
    const body =
      "Share your idea or describe the issue, and I will forward it to the developer.\n\n" +
      "- What page were you on?\n- What should change or what isn’t working?\n- Any screenshots/steps?\n";

    // Encode for URLs
    const su = encodeURIComponent(subject);
    const bo = encodeURIComponent(body);

    // Prefer Gmail compose (works for Propel’s Google Workspace users)
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
      email
    )}&su=${su}&body=${bo}`;

    // Fallback mailto (in case Gmail popup is blocked or user isn't logged in)
    const mailtoUrl = `mailto:${email}?subject=${su}&body=${bo}`;

    // Try to open Gmail in a new tab
    const newWin = window.open(gmailUrl, "_blank", "noopener,noreferrer");
    if (!newWin) {
      // Popup blocked → fallback
      window.location.href = mailtoUrl;
    }
  };

  return (
    <footer style={styles.wrap}>
      <img
        src="/icons/SSS_logo.png"
        alt="Sugarek School Support"
        style={styles.logo}
      />
      <button onClick={handleClick} style={styles.linkButton}>
        Submit ideas or request help
      </button>
    </footer>
  );
}

const styles = {
  wrap: {
    padding: "12px 16px 24px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    color: "#1f2a44",
    opacity: 0.98,
  },
  logo: {
    height: 80, // ⬅️ increase/decrease to change logo size
    width: "auto",
    display: "block",
    userSelect: "none",
    pointerEvents: "none",
  },
  linkButton: {
    appearance: "none",
    background: "none",
    border: "none",
    padding: 0,
    margin: 0,
    cursor: "pointer",
    color: "#1f2a44",
    textDecoration: "underline",
    fontSize: 15,
    lineHeight: 1.4,
  },
};
